<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="11">
        <v-row
          justify="space-between"
          align="center"
          class="mb-2"
        >
          <v-col cols="auto">
            <h2> Companies </h2>
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="primary"
              :to="{name:'companies-create'}"
            >
              Add Company
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="users"
          :options.sync="options"
          :loading="loading"
          :items-per-page="5"
          :footer-props="{'items-per-page-options':[5, 10, 25]}"
          :server-items-length="serverCount"
          show-expand
          class="elevation-1"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Search"
              clearable
              prepend-inner-icon="mdi-magnify"
              class="mx-4"
              @input="getData()"
            />
          </template>
          <template v-slot:expanded-item="{ item }">
            <td
              class="py-3"
              colspan="4"
            >
              <h3>{{ `${item.name }` }} <v-btn
                    icon
                    :to="{name: 'companies-edit', params: {companyId: item.id}}"
                  >
                    <v-icon> mdi-wrench </v-icon>
                  </v-btn>
                  <v-dialog
                    v-model="deleteCompanyDialog"
                    width="500"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                      >
                        <v-icon> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        Are you sure you want to delete this company?
                      </v-card-title>
                      <v-card-actions>
                        <v-row justify="end">
                          <v-col cols="auto">
                            <v-btn
                              text
                              @click="() => deleteCompanyDialog = false"
                            >
                              CANCEL
                            </v-btn>
                          </v-col>
                          <v-col cols="auto">
                            <v-btn
                              color="error"
                              text
                              @click="companyDelete(item.id)"
                            >
                              DELETE
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
              </h3>

              <v-row
                v-if="item.address"
                wrap
                no-gutters
              >
              <v-cols
                  cols="12"
                  class="mb-4"
                  md="4"
                >
                  <v-card
                    flat
                    tile
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">
                        <h4> Address </h4>
                      </v-col>
                      <v-col cols="12">
                        {{ item.address.streetName }}
                      </v-col>
                      <v-col cols="12">
                        {{ item.address.streetName2 }}
                      </v-col>
                      <v-col cols="12">
                        {{ item.address.city }}, {{ item.address.state }} {{ item.address.zipCode }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Created At: </b> {{ shortFormatDate(item.createdAt) }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Modified At: </b> {{ shortFormatDate(item.modifiedAt) }}
                      </v-col>
                    </v-row>
                  </v-card>
                </v-cols>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DateTime } from 'luxon';
import { companyTable, companyDelete } from '../services/companies';

export default {
  data() {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'City', align: 'start', value: 'address.city' },
        { text: 'State', align: 'start', value: 'address.state' },
        { text: 'Phone', align: 'start', value: 'phone' },
      ],
      users: [],
      rowsPerPageItems: [5, 10, 10],
      options: {},
      loading: false,
      serverCount: 0,
      deleteCompanyDialog: false,
      search: '',
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const { data } = await companyTable(this.search, this.options?.page, this.options?.itemsPerPage);
      this.serverCount = data?.count;
      this.users = data?.results;
      this.loading = false;
    },
    async companyDelete(id) {
      await companyDelete(id);
      await this.getData();
    },
    shortFormatDate(isoString) {
      return isoString ? DateTime.fromISO(isoString)
        .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS) : '--';
    },
  },
};
</script>

<style>

</style>
